import React, { Component, PropTypes } from 'react';
import { SparkToggleSwitch } from '../ui/spark';

class ConfigurationCheckboxIcon extends Component {
    componentDidMount() {
        this.checkBox = new SparkToggleSwitch(this.checkboxMount);
    }

    render() {
        const { code, desc, iconCode, isDisabled, style, title, value } = this.props;

        return (
            <div style={style}>
                <label className="col-xs-12 spark-checkbox" ref={node => (this.checkboxMount = node)}>
                    <input
                        checked={value}
                        className="spark-checkbox__input"
                        disabled={isDisabled}
                        onChange={() => this.props.onChange(code, value)}
                        type="checkbox"
                    />
                    <span className="spark-checkbox__box"></span>
                    <span
                        style={{ marginTop: 5, width: '50px', minWidth: '50px', marginLeft: 20, fontSize: 32 }}
                        className={`spark-icon--fill spark-icon-${iconCode}`}
                    />
                    <span className="spark-label">
                        <h4>{title}</h4>
                        <p>{desc}</p>
                    </span>
                </label>
            </div>
        );
    }
}

ConfigurationCheckboxIcon.defaultProps = {
    code: '',
    isDisabled: false,
    onChange: () => {},
    value: false
};

ConfigurationCheckboxIcon.propTypes = {
    code: PropTypes.string.isRequired,
    desc: PropTypes.string,
    iconCode: PropTypes.string,
    isDisabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    title: PropTypes.string,
    value: PropTypes.bool.isRequired
};

export default ConfigurationCheckboxIcon;



// WEBPACK FOOTER //
// ./src/components/widgets/ConfigurationCheckboxIcon.js